import axios from 'axios';
import { BASE_URL } from './api';


export async function createUserWorkflowStep(token, data) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/user_workflow_steps/create_user_workflow_step/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function createMultipleUserWorkflowSteps(token, data) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/user_workflow_steps/create_multiple_user_workflow_steps/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function updateUserWorkflowStep(token, data, userWorkflowStepId) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/user_workflow_steps/${userWorkflowStepId}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function deleteUserWorkflowStep(token, userWorkflowStepId) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/user_workflow_steps/${userWorkflowStepId}/`,
        headers: { 
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}
